exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2NSEQOLMgK3W5ENACALfCs{height:63px;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._2NSEQOLMgK3W5ENACALfCs{margin:1px 0 0 1px}html[dir=rtl] ._2NSEQOLMgK3W5ENACALfCs{margin:1px 1px 0 0}", ""]);

// exports
exports.locals = {
	"shimmerItemWrapper": "_2NSEQOLMgK3W5ENACALfCs"
};